import React from "react";
import { Card, Col, Row, Tabs } from "antd";
import { parseAsStringEnum, useQueryState } from "nuqs";

import ClientAdvisor from "~/modules/Advisor/ClientAdvisor";
import BotsConfig from "~/modules/Automation/BotsConfig/BotsConfig";
import AutomationList from "~/modules/Automation/ProgramAutomation/AutomationList";
import MessageTemplatesList from "./MessageTemplates/MessageTemplatesList";

const automationTabKeys = ["programAutomation", "botsConfig", "messagesTemplates", "advisor"] as const;
type AutomationTabKey = (typeof automationTabKeys)[number];

const Automation = () => {
  const [activeTab, setActiveTab] = useQueryState(
    "tab",
    parseAsStringEnum<AutomationTabKey>([...automationTabKeys]).withDefault("programAutomation"),
  );

  return (
    <Row className="p-0 lg:p-6">
      <Col xs={24}>
        <Card title="Automatyzacje" className="shadow">
          {/* destroyInactiveTabPane: ClientAdvisor drives its own `?advisorTab` query param,
              so it must mount only once its pane is selected, not on page render. */}
          <Tabs
            activeKey={activeTab}
            onChange={(key) => void setActiveTab(key as AutomationTabKey)}
            destroyInactiveTabPane
            items={[
              { key: "programAutomation", label: "Automatyzacje programu", children: <AutomationList /> },
              { key: "botsConfig", label: "Konfiguracja botów", children: <BotsConfig /> },
              { key: "messagesTemplates", label: "Szablony wiadomości", children: <MessageTemplatesList /> },
              { key: "advisor", label: "AI Opiekunka", children: <ClientAdvisor /> },
            ]}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default Automation;
